(function () {
  'use strict';
  function quoteURL(anchor, form) {
    const url = new URL(anchor.href, window.location.origin);
    // Unpriced variants keep their native purchase control disabled. Read its
    // selected value for the inquiry without enabling or submitting that control.
    const selectedId = form?.elements?.namedItem('id')?.value || (form ? new FormData(form).get('id') : null);
    const ids = JSON.parse(anchor.dataset.variantIds || '[]').map(String);
    const titles = JSON.parse(anchor.dataset.variantTitles || '[]');
    const index = ids.indexOf(String(selectedId));
    if (index >= 0 && titles[index] !== 'Default Title') url.searchParams.set('size', titles[index]); else url.searchParams.delete('size');
    const productURL = new URL(anchor.dataset.productUrl, window.location.origin);
    if (selectedId) productURL.searchParams.set('variant', String(selectedId));
    url.searchParams.set('product_url', productURL.pathname + productURL.search);
    const quantity = form ? new FormData(form).get('quantity') : null;
    if (/^\d{1,6}$/.test(String(quantity)) && Number(quantity) > 0) url.searchParams.set('quantity', String(quantity)); else url.searchParams.delete('quantity');
    return url.href;
  }
  function inquiryContext(search, origin) {
    const params = new URLSearchParams(search);
    const product = (params.get('product') || '').slice(0, 250).trim();
    const size = (params.get('size') || '').slice(0, 200).trim();
    const quantity = params.get('quantity') || '';
    const result = { intent: ['business', 'quote', 'retailer'].includes(params.get('intent')) ? params.get('intent') : 'business', product: product && size ? `${product} (${size})` : product, quantity: /^\d{1,6}$/.test(quantity) && Number(quantity) > 0 ? quantity : '', productURL: '' };
    try {
      const source = new URL(params.get('product_url') || '', origin);
      if (source.origin === origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+$/i.test(source.pathname)) {
        const variant = source.searchParams.get('variant');
        source.search = ''; source.hash = '';
        if (/^\d{1,20}$/.test(variant || '')) source.searchParams.set('variant', variant);
        result.productURL = source.href;
      }
    } catch { /* Invalid context does not block an inquiry. */ }
    return result;
  }
  function init() {
    document.querySelectorAll('[data-business-quote]').forEach(anchor => {
      if (anchor.dataset.ready) return;
      anchor.dataset.ready = 'true';
      const form = anchor.closest('.product--outer')?.querySelector('[data-product-form]');
      const update = () => { try { anchor.href = quoteURL(anchor, form); } catch { /* Retain the product-level fallback link. */ } };
      ['click', 'focus', 'contextmenu'].forEach(event => anchor.addEventListener(event, update));
      form?.addEventListener('change', () => setTimeout(update, 0));
      update();
    });
    const form = document.querySelector('#BusinessInquiryForm');
    if (!form || form.dataset.ready) return;
    form.dataset.ready = 'true';
    if (form.querySelector('[data-business-result]')) { form.querySelector('[data-business-result]').focus(); return; }
    const context = inquiryContext(window.location.search, window.location.origin);
    form.querySelector('[data-business-intent]').value = context.intent;
    if (context.product) form.querySelector('[data-business-products]').value = context.product;
    if (context.quantity) form.querySelector('[data-business-quantity]').value = context.quantity;
    form.querySelector('[data-business-product-url]').value = context.productURL;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { quoteURL, inquiryContext };
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
    document.addEventListener('shopify:section:load', init);
  }
})();
